// extracted by mini-css-extract-plugin
module.exports = {"ad":"Billboard_ad__ZKgw8"};